package com.devsusana.portfolio.styles

import com.varabyte.kobweb.compose.ui.graphics.Color
import com.varabyte.kobweb.silk.theme.colors.ColorMode

/**
 * Color palette and theme tokens for devsusana-portfolio.
 */
object SitePalette {
    val androidGreen = Color.rgb(0x3D, 0xDC, 0x84)
    val accentCyan = Color.rgb(0x38, 0xBD, 0xF8)
    val accentPurple = Color.rgb(0xA8, 0x55, 0xF7)

    fun background(colorMode: ColorMode): Color {
        return when (colorMode) {
            ColorMode.LIGHT -> Color.rgb(0xFA, 0xFA, 0xF9)
            ColorMode.DARK -> Color.rgb(0x0F, 0x17, 0x2A) // slate-900
        }
    }

    fun surface(colorMode: ColorMode): Color {
        return when (colorMode) {
            ColorMode.LIGHT -> Color.rgb(0xFF, 0xFF, 0xFF)
            ColorMode.DARK -> Color.rgb(0x1E, 0x29, 0x3B) // slate-800
        }
    }

    fun surfaceBorder(colorMode: ColorMode): Color {
        return when (colorMode) {
            ColorMode.LIGHT -> Color.rgb(0xE2, 0xE8, 0xF0) // slate-200
            ColorMode.DARK -> Color.rgb(0x33, 0x41, 0x55) // slate-700
        }
    }

    fun textPrimary(colorMode: ColorMode): Color {
        return when (colorMode) {
            ColorMode.LIGHT -> Color.rgb(0x0F, 0x17, 0x2A)
            ColorMode.DARK -> Color.rgb(0xF8, 0xFA, 0xFC)
        }
    }

    fun textSecondary(colorMode: ColorMode): Color {
        return when (colorMode) {
            ColorMode.LIGHT -> Color.rgb(0x64, 0x74, 0x8B) // slate-500
            ColorMode.DARK -> Color.rgb(0x94, 0xA3, 0xB8) // slate-400
        }
    }

    fun primaryAction(colorMode: ColorMode): Color {
        return when (colorMode) {
            ColorMode.LIGHT -> Color.rgb(0x02, 0x84, 0xC7) // sky-600
            ColorMode.DARK -> Color.rgb(0x38, 0xBD, 0xF8) // sky-400
        }
    }
}
